module.exports = __webpack_public_path__ + "img/ar21.6fb15344.jpg";